import script from "./games-filter-mobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./games-filter-mobile.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__